module.exports = __webpack_public_path__ + "img/文章头图2.7a897160.png";